import { pageconfigurationsApi } from 'app/src/services/welfareportal/'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const getCatalogPageConfig = http.get<object, DefaultBodyType, pageconfigurationsApi.Page>(
  apiBaseUrl + '/DEFAULT/pages/catalog',
  () => {
    return HttpResponse.json([
      {
        id: 'catalog',
        sections: [
          {
            renderingMode: 'native',
            sectionName: 'CatalogInformativeBannerSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'FavouritesBanner',
          },
          {
            renderingMode: 'native',
            sectionName: 'CatalogCategoriesSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'CatalogProductListSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'SuggestPartnershipSection',
          },
        ],
      },
    ])
  },
)

export const catalogPageConfigHandlers = [getCatalogPageConfig]
